// extracted by mini-css-extract-plugin
var _1 = "mention_yqash";
export { _1 as "mention" }
